import "./index.scss";

export const IconButton = ({ IconComponent, ...props }) => {
  return (
    <div className="icon-button" {...props}>
      <IconComponent />
    </div>
  );
};
